import * as AllMaterialIcons from '@material-ui/icons';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PendingIcon from '@mui/icons-material/Pending';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';

const statuses = {
    '1': {
        icon: <AllMaterialIcons.HistoryRounded />,
        label: 'Pending Carrier Assignment',
        export: true
    },
    '2': {
        icon: <AllMaterialIcons.RotateLeftRounded />,
        label: 'Pending Carrier Acceptance',
        export: true
    },
    '3': {
        icon: <AllMaterialIcons.PlayForWorkRounded />,
        label: 'Load Accepted',
        export: true
    },
    '4': {
        icon: <AllMaterialIcons.TrendingUpRounded />,
        label: 'In-Transit',
        exportLabel: 'Transit Began'
    },
    '5': {
        icon: <AllMaterialIcons.LocalShippingRounded />,
        label: 'Delivered'
    },
    '6': {
        icon: <AllMaterialIcons.DoneAllRounded />,
        label: 'Complete (Billing)',
        exportLabel: 'Completed'
    },
    '7': {
        icon: <AllMaterialIcons.Block />,
        label: 'Cancelled',
        exportLabel: 'Load Cancelled',
        export: true
    },
    '8': {
        icon: <AllMaterialIcons.NewReleasesOutlined />,
        label: 'Load Created',
        export: true
    },
    '9': {
        icon: <AllMaterialIcons.BeenhereOutlined />,
        label: 'Amerit Confirmed',
        export: true
    },
    '10': {
        icon: <AllMaterialIcons.Error />,
        label: 'Exception',
        export: true
    },
    '11': {
        icon: <AllMaterialIcons.Block />,
        label: 'Cancelled in Parq',
    },
    '12': {
        icon: <AllMaterialIcons.PauseCircleOutlineOutlined />,
        label: 'Pending Client Approval',
    },
    '13': {
        icon: <AllMaterialIcons.NewReleasesOutlined />,
        label: 'Load Created - managed by client'
    },
    '14': {
        icon: <PendingIcon style={{ color: '#0291f8' }} />,
        label: 'Pending Pricing Approval',
    },
    '15': {
        icon: <PriceCheckIcon style={{ color: '#0291f8'}}/>,
        label: 'Pricing Approved',
    },
    '16': {
        icon: <DoNotDisturbOnIcon style={{ color: '#0291f8' }} />,
        label: 'Rejected by Client'
    }
};

export default statuses;